import { ComponentType, PropsWithChildren } from 'react';

import {
  Extension,
  attachComponentData,
  useElementFilter,
} from '@backstage/core-plugin-api';

export type EditorDataExtensionOptions = {
  id: string;
  DataProvider: ComponentType<PropsWithChildren<{}>>;
};

const EDITOR_DATA_EXTENSION_KEY = 'confidence.editor-data-extension';

export const createEditorDataExtension = (
  options: EditorDataExtensionOptions,
): Extension<() => null> => {
  return {
    expose() {
      const EditorDataExtensionDataHolder = () => null;

      attachComponentData(
        EditorDataExtensionDataHolder,
        EDITOR_DATA_EXTENSION_KEY,
        options,
      );

      return EditorDataExtensionDataHolder;
    },
  };
};

export const EditorDataExtensions: ComponentType<PropsWithChildren<{}>> = ({
  children,
}): JSX.Element | null => {
  const extensions = useElementFilter(children, elements =>
    elements.findComponentData<EditorDataExtensionOptions>({
      key: EDITOR_DATA_EXTENSION_KEY,
    }),
  );

  (EditorDataExtensions as any).__extensions__ = extensions;

  return null;
};

export const useEditorDataExtensions = (): EditorDataExtensionOptions[] => {
  return (EditorDataExtensions as any).__extensions__ || [];
};
